import { render, staticRenderFns } from "./SMSBrandNameSubscriptionTransaction.vue?vue&type=template&id=04412007"
import script from "./SMSBrandNameSubscriptionTransaction.vue?vue&type=script&lang=js"
export * from "./SMSBrandNameSubscriptionTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports